class ProcessSwitch extends HTMLElement {
    constructor() {
        super();
        this.inputValue = 1;
        this.initialRender();
        this.querySelectorAll('.process__number').forEach((value) => {
            value.addEventListener('click', this.renderSection)
        });
        // this.tabsSwitch = document.querySelector('.tabs__switch');
    }

    initialRender() {
        if (this.inputValue == 1) {
            let renderNumber = document.querySelector(`.process__number[data-index="${this.inputValue}"]`);
            if(renderNumber) {
                renderNumber.classList.remove('inactive__number');
                renderNumber.classList.add('active__number');
            }
            let renderContent = document.querySelector(`.switcher__content[data-index="${this.inputValue}"]`);
            if(renderContent) {
                renderContent.classList.remove('inactive__content');
                renderContent.classList.add('active__content');
            }
        }
    }

    renderSection() {
        let inputValue = this.dataset.index;
        document.querySelectorAll('.process__number').forEach((item) => {
            item.classList.remove('active__number')
            item.classList.add('inactive__number');
        })
        document.querySelectorAll('.switcher__content').forEach((item) => {
            item.classList.remove('active__content')
            item.classList.add('inactive__content');
        })
        let renderNumber = document.querySelector(`.process__number[data-index="${inputValue}"]`);
        renderNumber.classList.remove('inactive__number');
        renderNumber.classList.add('active__number');
        let renderContent = document.querySelector(`.switcher__content[data-index="${inputValue}"]`);
        renderContent.classList.remove('inactive__content');
        renderContent.classList.add('active__content');
    }

}

customElements.define('process-switch', ProcessSwitch);